// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"effa610f","455":"0fd70ef7","977":"15a33241"}[chunkId] + ".chunk.js";
};